module.exports = __webpack_public_path__ + "static/digital_dental_solutions_logo.4ccafd3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/img/vendors/digital_dental_solutions_logo.png
// module id = 660
// module chunks = 172845445241205